import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";

const Header = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const userData = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (user?.email !== userData?.email) {
      setUser(userData);
    }
  }, [userData, user]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    navigate("/login");
  };

  return (
    <header className="header">
      <div className="d-flex align-items-center justify-content-between w-100 mx-4">
        <div className="logo">
          <Link to="/" className="logo-link">
            <img
              src="/white-logo.png"
              alt="Logo"
            />
          </Link>
        </div>
        <nav className="nav">
          <ul className="nav-list">
            <li>
              <Link to="/" className="nav-item">
                Home
              </Link>
            </li>
            <span className="text-white">|</span>
            <li>
              <Link to="/about" className="nav-item">
                About
              </Link>
            </li>
            <span className="text-white">|</span>
            <li>
              <Link to="/posts" className="nav-item">
                Posts
              </Link>
            </li>
            <span className="text-white">|</span>
            <li>
              <Link to="/blogs" className="nav-item">
                Blogs
              </Link>
            </li>
          </ul>
        </nav>

        <div className="user">
          {user ? (
            <Dropdown align="end">
              <Dropdown.Toggle
                variant="link"
                id="dropdown-basic"
                className="p-0 border-0"
              >
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSppkoKsaYMuIoNLDH7O8ePOacLPG1mKXtEng&s"
                  alt="User Icon"
                  className="user-avatar"
                />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {user.role === "admin" && (
                  <Dropdown.Item as={Link} to="/dashboard">
                    Dashboard
                  </Dropdown.Item>
                )}
          
                <Dropdown.Item  className="logout" onClick={handleLogout}>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <div className="auth-links">
              <Link to="/login" className="auth-link">
                Login
              </Link>
              <span className="text-white">|</span>
              <Link to="/register" className="auth-link">
                Sign Up
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
